const FEDERAL_BILL_REF = /^(\d+)-(hr|s|hres|sres|hjres|sjres|hconres|sconres)-(\d+)$/i;
const UNSAFE_IDENTIFIER_CHARACTERS = /[\u0000-\u001f\u007f-\u009f\u202a-\u202e\u2066-\u2069]/;

/**
 * Normalize references used by policy-intelligence entity links.
 *
 * Federal bill references have a stable lowercase canonical form. Other
 * identifiers (including case-sensitive state-bill IDs) are preserved after
 * Unicode/whitespace safety checks so we do not invent a canonical form for
 * an upstream state system.
 */
export function normalizePolicyIntelligenceBillRef(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const normalized = value.normalize("NFKC").trim();
  if (!normalized || normalized.length > 100 || UNSAFE_IDENTIFIER_CHARACTERS.test(normalized)) return null;
  return FEDERAL_BILL_REF.test(normalized) ? normalized.toLowerCase() : normalized;
}
